import { styled } from '@mui/material'
import { useLocation, useNavigate } from 'react-router-dom'
import { BucketMedia } from '../../../../graphql/generated'
import { imagePlaceholder, videoPlaceholder } from '../../utils/placeholders'
import formatImageProxyUrl from '../../utils/formatImageProxyUrl'
import config from '../../../../config'

interface Props {
  media: BucketMedia
  crop?: boolean
}

interface ImageProps {
  isBlurred?: boolean
  crop?: boolean
}

const StyledImage = styled('img', {
  shouldForwardProp: (prop: string) => prop !== 'crop' && prop !== 'isBlurred'
})<ImageProps>(({ isBlurred, crop }) => ({
  objectFit: crop ? 'cover' : 'contain',
  filter: isBlurred ? 'blur(5px) brightness(95%)' : 'none',
  width: '100%',
  height: '100%'
}))

export default function Thumbnail({ media, crop }: Props) {
  const location = useLocation()
  const navigate = useNavigate()
  const placeHolder = media?.mediaType?.includes('video') ? videoPlaceholder : imagePlaceholder
  let src = media?.filename ? formatImageProxyUrl(media, 180) : placeHolder
  const isBlurred = false
  if (media.isBanned) {
    src = `${config.assets.placeholderThumbnail}`
  }

  const handleClick = () => {
    const path = location.pathname
    const arr = path.split('/')
    arr.pop()
    navigate(`${arr.join('/')}/${media.id}`)
  }

  const handleError = (e: React.SyntheticEvent<HTMLImageElement>) => {
    e.currentTarget.src = media?.mediaType?.includes('video') ? videoPlaceholder : imagePlaceholder
    e.currentTarget.srcset = media?.mediaType?.includes('video') ? videoPlaceholder : imagePlaceholder
  }

  return (
    <StyledImage
      data-test={`carousel-thumbnail-${media.id}`}
      crop={crop}
      isBlurred={isBlurred}
      id="thumbnail-image"
      src={src}
      srcSet={src}
      alt={media?.id}
      onError={handleError}
      onClick={handleClick}
    />
  )
}

Thumbnail.defaultProps = {
  crop: false
}
